import React, { useEffect, useState } from "react";
import {
  GetAllMeeting,
  GetMeetingById,
  GetZoomRefreshToken,
  GetZoomAccessToken,
} from "./ZoomApi";
import { toast } from "react-toastify";
import Loader from "../../../utils/loader/Loader";

const ViewMeeting = () => {
  const [meetingId, setMeetingId] = useState("");
  const [responseMeetingAll, setResponseMeetingAll] = useState([]);
  const [responseMeetingById, setResponseMeetingById] = useState([]);
  const [authData, setAuthData] = useState(null);
  const [zoomAccessToken, setZoomAccessToken] = useState("");
  const [zoomRefreshToken, setZoomRefreshToken] = useState("");
  const [loader, setLoader] = useState(false);
  let accessTokenZoom = localStorage.getItem("acc_token") ?? "";

  const refreshToken = async () => {
    const response = await GetZoomRefreshToken();
    if (response !== "") {
      setZoomRefreshToken(response);
    }
    console.log(response, "refresh token");
    return response;
  };

  const accessToken = async (token) => {
    const response = await GetZoomAccessToken(token);
    if (response !== "") {
      setZoomAccessToken(response);
    }
    console.log(response, "access token");
    return response;
  };

  const getAllMeeting = async (token) => {
    await GetAllMeeting(token).then((response) => {
      console.log(response);
      if (
        response?.data?.total_records > 0 &&
        response?.data?.meetings?.length > 0
      ) {
        setResponseMeetingAll(response?.data?.meetings);
      } else if (
        response?.data?.code === 124 ||
        response?.data?.message.includes("Invalid")
      ) {
        toast.error("Invalid access token");
      }
    });
  };

  const formatDateTime = (isoString) => {
    const dateObj = new Date(isoString);

    const dateOnly = isoString.split("T")[0];

    // Format Date: 16 January 2025
    const formattedDate = new Intl.DateTimeFormat("en-US", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).format(dateObj);

    // Format Time: 09:00 AM
    const formattedTime = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata", // Converts to IST (Indian Standard Time)
    }).format(dateObj);

    return { formattedDate, formattedTime, dateOnly };
  };

  const getMeetingById = async () => {
    await GetMeetingById(meetingId).then((response) => {
      if (!response) {
        console.log("apiError");
        return;
      }

      if (response?.data?.id > 0) {
        setResponseMeetingById(response?.data);
      }
    });
  };

  function isJwtExpired(token) {
    try {
      // Split the token and decode the payload
      const payload = JSON.parse(atob(token.split(".")[1]));

      // Get current time in seconds
      const currentTime = Math.floor(Date.now() / 1000);

      // Check if current time is greater than exp
      return currentTime >= payload.exp;
    } catch (e) {
      console.error("Invalid JWT token", e);
      return true; // assume expired if there's an error
    }
  }

  useEffect(() => {
    const callZoomApi = async () => {
      setLoader(true);
      try {
        if (accessTokenZoom === "") {
          const refToken = await refreshToken();
          if (refToken !== "") {
            console.log(refToken, "refToken");
            const accToken = await accessToken(refToken);
            if (accToken !== "") {
              localStorage.setItem("acc_token", accToken);
              console.log(accToken, "accToken");
              await getAllMeeting(accToken);
            }
          }
          console.log("api hit auth toke");
        } else {
          let isTokenExpire = isJwtExpired(accessTokenZoom);
          if (!isTokenExpire) {
            await getAllMeeting(accessTokenZoom);
            console.log("get all meeting api hit");
          } else {
            accessTokenZoom = "";
            callZoomApi();
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoader(false);
      }
    };
    callZoomApi();
  }, []);

  function getTodayAndTomorrowMeetings(meetings) {
    //const today = parse.DateTimeFormat("2025-03-25T07:26:18Z"); //new Date();
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    return responseMeetingAll.filter((meeting) => {
      const meetingDate = new Date(meeting.start_time);
      const meetingDateString = meetingDate.toDateString();

      return (
        meetingDateString === today.toDateString() ||
        meetingDateString === tomorrow.toDateString()
      );
    });
  }

  function getLastTwoMonthsMeetings(meetings) {
    const now = new Date();
    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(now.getMonth() - 2); // Move back 2 months

    return meetings.filter((meeting) => {
      const meetingDate = new Date(meeting.start_time);
      return meetingDate >= twoMonthsAgo && meetingDate <= now;
    });
  }

  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];

  return (
    <>
      {loader ? (
        <>
          <div className="flex justify-center items-center h-[80%]">
            <Loader type="spinningBubbles" color="#2e376c" />
          </div>
        </>
      ) : (
        <>
          {/* <div className="flex flex-wrap items-end gap-4 lg:gap-6 px-5 lg:px-[50px] m-5">
           
            <div className="flex flex-col">
              <label
                htmlFor="meetingId"
                className="text-[#000] font-semibold mb-1 text-left"
              >
                Meeting ID:
              </label>
              <input
                id="meetingId"
                type="text"
                name="meetingId"
                maxLength={12}
                placeholder="Enter Meeting ID"
                onChange={(e) => setMeetingId(e.target.value)}
                className="border border-[#e8eaf1] rounded-lg py-2 px-4 min-w-[250px]"
              />
            </div>

          
            <div className="flex items-end">
              <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-all h-[42px]">
                Search
              </button>
            </div>
          </div> */}

          <div className="bg-[#F4F4FA] p-4 md:p-8 h-[calc(100%-8%)]">
            <div className="flex justify-between mb-4 px-4">
              <div className="flex">
                <h2 className="text-[20px] text-[#101942] font-bold">
                  Meeting List
                </h2>
                <p className="bg-gradient-to-r from-[#FF9200] to-[#F6BF52] rounded-[23px] text-[16px]  text-white py-[2px] px-[15px] ml-3">
                  {getTodayAndTomorrowMeetings(responseMeetingAll)?.length}
                </p>
              </div>
            </div>
            <div className="bg-[#fff] rounded-[30px] h-[calc(100%_-_8%)]">
              <div className="lg:p-[15px] md:p-[30px] p-[15px] flex flex-row flex-wrap overflow-y-scroll md:h-[calc(100vh-33vh)] h-[calc(100vh-35vh)] h=[100vh] no-scrollbar p">
                <>
                  {!loader &&
                  getTodayAndTomorrowMeetings(responseMeetingAll)?.length ===
                    0 ? (
                    <div className="flex flex-col justify-center w-full items-center">
                      <img
                        src="../Images/screen1.svg"
                        alt="Screening 1"
                        className="lg:w-[30%] lg:mb-[30px]"
                      />
                      <h1 className="text-lg font-semibold">
                        {"No Data Found!"}
                      </h1>
                    </div>
                  ) : (
                    <>
                      {getTodayAndTomorrowMeetings(responseMeetingAll)?.map(
                        (data, index) => (
                          <div
                            key={index}
                            className="rounded-[12px] bg-[#fff] xl:w-[90%] lg:w-[90%] w-[100%] lg:mx-[20px] my-[10px] shadow-[0px_0px_20px_#48456C21] h-fit"
                          >
                            <div className="flex flex-col mx-[20px] mb-[20px] pt-[20px]">
                              <div className="flex flex-row justify-between items-center">
                                {/* Title Section */}
                                <div className="flex flex-col text-left">
                                  <p className="mb-[5px] font-medium">
                                    <b> {data.topic}</b>
                                    <p className="text-[#A9A9A9] text-[12px]">
                                      Agenda: {data.agenda}
                                    </p>
                                  </p>
                                </div>
                                {/* Date Section */}
                                <p className="text-[#A9A9A9] text-[12px] text-right">
                                  {
                                    formatDateTime(data.start_time)
                                      .formattedDate
                                  }
                                </p>
                              </div>

                              {/* Card Content */}
                              <div className="flex flex-row items-center mt-[15px] p-[10px] bg-[#F9F9F9] rounded-[8px]">
                                {/* Image */}
                                <img
                                  src={"../Images/zoom-icon.png"}
                                  alt="Zoom Icon"
                                  className="w-[50px] h-[50px] rounded-full"
                                />

                                {/* User Info */}
                                <div className="flex flex-col ml-[15px]">
                                  <p className="text-[#848BAA] text-[13px] m-0 text-start">
                                    Start Time:{" "}
                                    {
                                      formatDateTime(data.start_time)
                                        .formattedTime
                                    }
                                  </p>
                                  <p className="text-[#848BAA] text-[13px] m-0 text-start">
                                    Duration: {data.duration}
                                  </p>
                                </div>

                                {/* Action Buttons */}
                                <div className="flex ml-auto gap-[10px]">
                                  <a
                                    className={`join-button w-[80px] ${
                                      formatDateTime(data.start_time)
                                        .dateOnly != formattedDate
                                        ? "disabled"
                                        : ""
                                    }`}
                                    target="_blank"
                                    href={data.join_url}
                                  >
                                    Join
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      )}
                    </>
                  )}
                </>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ViewMeeting;
